import React, {useState} from 'react';
import {connect} from 'react-redux';
import {getMindfile} from '../../../../state/actions/getDataActions';
import {useHistory} from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Typography,
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Loader from '../../../organisms/loader/Loader';

function MindfilesTable({getMindfile, mindfiles, pageNumber, setPageNumber, orderBy, setOrderBy, reverseOrder, setReverseOrder}) {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const navigateBack = () => {
    const newPageNumber = pageNumber-1;
    setPageNumber(newPageNumber);
  }

  const navigateNext = () => {
    const newPageNumber = pageNumber+1;
    setPageNumber(newPageNumber);
  }

  const viewMindfile = mindfileId => () => {
    setIsLoading(true);
    getMindfile(mindfileId, () => history.push('/explore'));
  }

  const manageMindfile = mindfileId => () => {
    setIsLoading(true);
    getMindfile(mindfileId, () => history.push('/admin/current'), true);
  }

  const mindfileRows = mindfiles.map(mindfile => (
    <TableRow key={mindfile.mindfile_id}>
      <TableCell>
        {mindfile.mindfile_name}
      </TableCell>
      <TableCell>
        {mindfile.username}
      </TableCell>
      <TableCell>
        {mindfile.email}
      </TableCell>
      <TableCell>
        {mindfile.created_at}
      </TableCell>
      <TableCell>
        <a href="#?" onClick={viewMindfile(mindfile.mindfile_id)}>View</a>
        &nbsp;|&nbsp;
        <a href="#?" onClick={manageMindfile(mindfile.mindfile_id)}>Manage</a>
      </TableCell>
    </TableRow>
  ));

  const arrowIcon = (direction) => {
    switch (direction) {
      case 'up':
        return <ArrowUpwardIcon style={{ fontSize: 15, marginRight: 4 }} />
      case 'down':
        return <ArrowDownwardIcon style={{ fontSize: 15, marginRight: 4 }} />
      default:
        return []
    }
  }

  const sortTable = column => () => {
    if (column === orderBy) {
      setReverseOrder((reverseOrder === 1) ? 0 : 1);
    }
    else {
      setOrderBy(column)
    }
  }

  if (isLoading) return <Loader />

  return (
    <Box>
      <TableContainer component={Box}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <Box style={{cursor: 'pointer', display:'inline-flex'}} onClick={sortTable('name')}>
                  {(orderBy === 'name') ? ((reverseOrder === 1) ? arrowIcon('down') : arrowIcon('up')) : []}
                  <Box style={{displya: 'inline'}}><Typography variant="subtitle2"><strong>Mindfile</strong></Typography></Box>
                </Box>
              </TableCell>
              <TableCell>
                <Box style={{cursor: 'pointer', display:'inline-flex'}} onClick={sortTable('username')}>
                  {(orderBy === 'username') ? ((reverseOrder === 1) ? arrowIcon('down') : arrowIcon('up')) : []}
                  <Box style={{displya: 'inline'}}><Typography variant="subtitle2"><strong>Owner</strong></Typography></Box>
                </Box>
              </TableCell>
              <TableCell>
                <Box style={{cursor: 'pointer', display:'inline-flex'}} onClick={sortTable('email')}>
                  {(orderBy === 'email') ? ((reverseOrder === 1) ? arrowIcon('down') : arrowIcon('up')) : []}
                  <Box style={{displya: 'inline'}}><Typography variant="subtitle2"><strong>Email</strong></Typography></Box>
                </Box>
              </TableCell>
              <TableCell>
                <Box style={{cursor: 'pointer', display:'inline-flex'}} onClick={sortTable('created_at')}>
                  {(orderBy === 'created_at') ? ((reverseOrder === 1) ? arrowIcon('down') : arrowIcon('up')) : []}
                  <Box style={{displya: 'inline'}}><Typography variant="subtitle2"><strong>Account Created</strong></Typography></Box>
                </Box>
              </TableCell>
              <TableCell>
                <Typography variant="subtitle2"><strong>Actions</strong></Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{backgroundColor: "#fff"}}>
            {mindfileRows}
          </TableBody>
        </Table>
      </TableContainer>
      <Box mt={3} display="flex" justifyContent="center">
        {
          pageNumber > 1 ?
          <Box m={2} onClick={navigateBack} style={{cursor: 'pointer'}}>
            <NavigateBeforeIcon />
          </Box>
          : []
        }
        <Box m={2}>
          <Typography>{pageNumber}</Typography>
        </Box>
        {
          mindfiles.length ?
          <Box m={2} onClick={navigateNext} style={{cursor: 'pointer'}}>
            <NavigateNextIcon />
          </Box>
          : []
        }
      </Box>
    </Box>
  )
}

const mapStateToProps = state => ({

})

const mapDispatchToProps = {
  getMindfile,
}

export default connect(mapStateToProps, mapDispatchToProps)(MindfilesTable);
